export default __webpack_public_path__ + "static/media/carousel-3.714fde39.png";